import { Component, ElementRef, ViewChild, inject, signal } from '@angular/core';
import { ActiveMonitoringOverview } from './molecules/active-monitoring-overview/active-monitoring-overview';
import { CreatorLists } from './molecules/creator-lists/creator-lists';
import { Router } from '@angular/router';
import { MonitoringBriefs } from './molecules/monitoring-briefs/monitoring-briefs';

export type MonitorToolIcon =
  | 'search'
  | 'infinity'
  | 'image'
  | 'film'
  | 'video'
  | 'expand'
  | 'mic'
  | 'pencil';

export type MonitorToolCard = {
  label: string;
  description: string;
  new?: boolean;
  icon: string;
  /** Tailwind gradient classes for the icon square */
  gradient: string;
};

@Component({
  selector: 'app-monitoring',
  imports: [ActiveMonitoringOverview, CreatorLists, MonitoringBriefs],
  templateUrl: './monitoring.html',
  styleUrl: './monitoring.css',
})
export class Monitoring {
  @ViewChild('cardStrip') cardStrip?: ElementRef<HTMLDivElement>;

  activeFilter = signal<string>('all');

  /** layout variables */
  selectedTab = signal<'monitoring-home' | 'creator-lists' | 'monitoring-briefs'>('monitoring-home');
  /** layout variables - END */



  readonly toolCards: MonitorToolCard[] = [
    { label: 'Deliverables', description: 'Find content that matches specific brief requirements.', icon: 'deliverables', gradient: 'from-zinc-500 to-zinc-600' },
    { label: 'Brand Issues', description: 'Monitor all creator content to identify brand issues and concerns.', icon: 'safety', gradient: 'from-brand-agency to-brand-deep-purple' },
    // { label: 'Creator Outreach', description: 'Discover new creators based on specific criteria.', icon: 'image', gradient: 'from-sky-500 to-blue-700' },
    { label: 'Content by Topic', description: 'Monitor content by specific topics and keywords.', icon: 'topic', gradient: 'from-sky-500 to-brand-deep-purple', new: true },
    // { label: 'Content by Mention', description: 'Monitor content based on brand mentions.', icon: 'video', gradient: 'from-emerald-500 to-teal-700' },
  ];

  /** Services */
  private router = inject(Router);
  /** Services - END */

  setFilter(id: string): void {
    this.activeFilter.set(id);
  }

  scrollCardStrip(dir: -1 | 1): void {
    const el = this.cardStrip?.nativeElement;
    if (!el) return;
    el.scrollBy({ left: dir * 280, behavior: 'smooth' });
  }

  getTabClass(tab: 'monitoring-home' | 'creator-lists' | 'monitoring-briefs') {
    return this.selectedTab() === tab
      ? 'bg-gray-200 text-gray-900 dark:bg-white/10 dark:text-gray-200'
      : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200';
  }

  startMonitoring(label: string): void {
    this.router.navigate(['/create-monitoring-brief', label]);
  }
}
